
const ModalLayout = ({ children, isModalOpen, onClose }) => {


  const handleCloseItSelf = (e) => {
      if (e.target === e.currentTarget) {
        onClose?.();
      }
  };

  return (
    <div
      className={`fixed inset-0 z-[9999]  bg-slate-200/20 backdrop-blur-sm h-screen  items-center justify-center ${
        isModalOpen ? "flex" : "hidden"
      }`}
      onClick={(e) => handleCloseItSelf(e)}
    >
      {children}
    </div>
  );
};

export default ModalLayout;
